import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import generalActions from 'redux/actions/generalActions'
import matchingPairsCreationToolActions from 'redux/actions/matching_pairs_ct_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import containerSelector from 'redux/selectors/matching_pairs/creation_tool_timer_modal_selector'

import TimerModal from 'views/modals/timer_modal'

class MatchingPairsTimerModalContainer extends PureComponent {

	closeModalHandler = () => {
		this.props.actions.closeModal(this.props.modalName)
	}

	render() {
		return (
			<TimerModal
				max={5999}
				min={0}
				step={15}
				value={this.props.value}
				saveHandler={this.props.actions.save}
				cancelHandler={this.props.actions.cancel}
				closeModalHandler={this.closeModalHandler}
			/>
		)
	}

}

function mapStateToProps(state) {
	return containerSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
		save: matchingPairsCreationToolActions.saveTimer,
		cancel: matchingPairsCreationToolActions.cancelTimer,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(MatchingPairsTimerModalContainer)
